import { useTranslation } from 'react-i18next';
import { FaPhoneVolume } from "react-icons/fa6";
import { Navbar, Nav, Container } from 'react-bootstrap';

import logoAr from 'src/assets/images/navbar/logo_ar.webp';
import logoEn from 'src/assets/images/navbar/logo_en.webp';

import { isRTL } from 'src/utils/global';
import styles from './styles.module.css';
import { Link as ScrollLink } from "react-scroll";

const NavLarge = () => {
    const { t, i18n } = useTranslation('common');

    const linkClassName = `${styles.item__link} nav-link`;

    // ✅ Select logo dynamically
    const currentLang = i18n.language;
    const logo =
        currentLang === 'ar'
            ? logoAr
            : logoEn;

    return (
        <header>
            <Navbar expand="xl" className={`${styles.nav} ${isRTL() && styles.rtl}`}>
                <Container className={styles.navContainer}>
                    {/* Logo */}
                    <Navbar.Brand href="/" className={styles.navBrand}>
                        <img src={logo} alt={t('nav.title')} />
                    </Navbar.Brand>

                    {/* Toggle for mobile */}
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    {/* Links */}
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                        <Nav className={styles.navLinks}>
                            <a href="/"
                                className={linkClassName}
                            > {t('nav.home')}
                            </a>


                            <ScrollLink to="aboutUs"
                                className={linkClassName}
                                smooth={true} duration={500}>  {t('nav.about')}</ScrollLink>

                            <ScrollLink to="services"
                                className={linkClassName}
                                smooth={true} duration={500}>  {t('nav.services')}</ScrollLink>
                            <ScrollLink to="gallery"
                                className={linkClassName}
                                smooth={true} duration={500}>  {t('nav.gallery')}</ScrollLink>

                            <ScrollLink to="whyUs"
                                className={linkClassName}
                                smooth={true} duration={500}>  {t('nav.whyUs')}</ScrollLink>

                            {/* 🟢 Contact Us as a button */}
                            <div className={styles.contactWrapper}>
                                <a href="https://wa.me/218912100092"
                                    target="_blank"
                                    rel="noreferrer"
                                    className={styles.contactButton}>
                                    <FaPhoneVolume />
                                </a>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default NavLarge;
